import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";

import Sidebar from "./Sidebar";
import Navigator from "./Navigation";
import ReloadList from "./reload/ReloadList";
import PurchaseHistory from "./reload/PurchaseHistory";
import NewsSlider from "../main/dashboard/NewsSlider";
import WashupHeader from "../main/dashboard/header/washupHeader";

import { useTranslation } from "react-i18next";
import { currency, getApiUrl, getStoreType } from "../../../dynamicController";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Modal } from "react-bootstrap";

import { saveTransactionType } from "../../../redux/actions/paymentActions";

import cleanproReloadBear from "../../../assets/images/icons/icn-credit.png"

import sha1 from "js-sha1";

const apiUrl = getApiUrl();
const STORETYPE = getStoreType()

const mySwal = withReactContent(Swal);

const Reload = ({ user, token, theme, saveTransactionType, environment }) => {
	const [toggled, setToggled] = useState(false);
	const [selected/*, setSelect*/] = useState("reload");
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState(null);
	const [rm, setRm] = useState(false);
	const [scan2pay, setScan2Pay] = useState(false);
	const [hitpay, setHitpay] = useState(false);
	const [pagbank, setPagbank] = useState(false);
	const [pagbankPublicKey, setPagbankPublicKey] = useState("");
	const [razer, setRazer] = useState(false);
	const [duitnow, setDuitnow] = useState(false);
	const [kiple, setKiple] = useState(false);
	const [kipleId, setKipleId] = useState(null);
	const [kipleHashValue, setKipleHashValue] = useState(null);
	const [ghl, setGhl] = useState(false);
	const [thai2c2p, setThai2c2p] = useState(false);
	const [rhbDuitnow, setRhbDuitnow] = useState(false);
	const [amount, setAmount] = useState("");
	const [transId, setTransId] = useState("");
	const [showModal, setShowModal] = useState(false);
	const [cleanproModal, setCleanproModal] = useState(false);
	const [selectedPkg, setSelectedPkg] = useState(null);
	const [bangkokbank, setBangkokbank] = useState(false);
	const [bangkokbankApp, setBangkokbankApp] = useState(false);
	const [cybersource, setCybersource] = useState(false);
	const [url, setUrl] = useState("");
	const [body, setBody] = useState([])
	const [formName, setFormName] = useState("")
	const [payway, setPayway] = useState(false);

	const formButtonClick = useRef();
	const kipleButtonClick = useRef();

	const history = useHistory();

	const { t } = useTranslation();

	useEffect(() => {
		if (!user) history.push("/");
		else
			axios
				.get(`/api/token/fetchPackages?operatorId=${user.store}`, { headers: { "Content-Type": "application/json", "auth-token": token } })
				.then(res => {
					setData(res.data.tokenPackages);
					setKiple(res.data.kiple);
					setRm(res.data.rm);
					setScan2Pay(res.data.scan2pay);
					setRazer(res.data.razer);
					setHitpay(res.data.hitpay);
					setDuitnow(res.data.duitnow);
					setPagbank(res.data.pagbank);
					setPagbankPublicKey(res.data.pagbankPublicKey);
					setGhl(res.data.ghl);
					setThai2c2p(res.data.thai2c2p);
					setRhbDuitnow(res.data.rhbduitnow);
					setBangkokbank(res.data.bangkokbank);
					setBangkokbankApp(res.data.bangkokbankApp);
					setCybersource(res.data.cybersource);
					setPayway(res.data.payway);
					setLoading(false);
				})
				.catch(err => {
					mySwal.fire(t("Error"), t(err.response.data.error), "error");
					setLoading(false);
				});
	}, []);

	useEffect(() => {
		if (kipleHashValue) {
			kipleButtonClick.current.click();
		}
	}, [kipleHashValue]);

	useEffect(() => {
		if (body.length > 0) {
			formButtonClick.current.click();
		}
	}, [body]);

	// const selectColor = val => (val === selected ? "selected-button" : null);

	const kiplePurchase = () => {
		// pay with kiplepay
		let ord_totalamt = parseFloat(selectedPkg.price).toFixed(2)
		setAmount(ord_totalamt)
		setLoading(true);
		axios
			.post("/api/token/kiplePurchase", { userId: user.id, pkgId: selectedPkg.id }, { headers: { "Content-Type": "application/json", "auth-token": token } })
			.then(res => {
				saveTransactionType("Reload")
				setKipleId(res.data.kipleId);
				setTransId(res.data.purchaseId);
				// $amount = str_replace(['.', '|'], '', $ord_totalamt);
				let amount = ord_totalamt.replace(/[.|]/g, '');
				// sha1($merchant_secret . $ord_mercID . $ord_mercref . $amount);
				let merchant_hashvalue = sha1(res.data.kipleSecret + res.data.kipleId + res.data.purchaseId + amount)
				if (environment === "development") {
					// eslint-disable-next-line no-useless-concat
					merchant_hashvalue = sha1("123456" + "80000155" + res.data.purchaseId + amount)
				}
				setKipleHashValue(merchant_hashvalue);
				setLoading(false);
			})
			.catch(err => {
				mySwal.fire(t("Error"), t(err.response.data.error), "error");
				setLoading(false);
			});
	}

	const scan2payPurchase = () => {
		// pay with Scan2Pay (Taiwan)
		setLoading(true);
		axios
			.post("/api/token/scan2payPurchase", { userId: user.id, pkgId: selectedPkg.id }, { headers: { "Content-Type": "application/json", "auth-token": token } })
			.then(res => {
				saveTransactionType("Reload")
				setLoading(false);
				if (!res.data.data) {
					history.push("/");
				} else {
					window.location.href = res.data.data;
				}
			})
			.catch(err => {
				mySwal.fire(t("Error"), t(err.response.data.error), "error");
				setLoading(false);
			});
	}

	const purchase = (type) => {
		setLoading(true);
		let param = {
			userId: user.id,
			pkgId: selectedPkg.id,
			type,
			osPlatform: /iPhone|iPad|iPod/i.test(navigator.userAgent) ? "IOS" : "ANDROID",
		}
		axios
			.post("/api/token/reload", param, { headers: { "Content-Type": "application/json", "auth-token": token } })
			.then(res => {
				saveTransactionType("Reload")
				setLoading(false);
				if (res.data.data.type === "form") {
					setUrl(res.data.data.url)
					setBody(res.data.data.body)
					if (res.data.data.formName) {
						setFormName(res.data.data.formName)
					}
				} else if (res.data.data.type === "url" && type === "bangkokbankapp") {
					history.push("/guide/bangkokbanklink", { url: res.data.data.url, transactionId: res.data.transactionId })
				} else if (res.data.data.type === "url") {
					window.location.href = res.data.data.url
				} else if (res.data.data.type === "image" && (type === "duitnow" || type === "rhbduitnow")) {
					let duitnowState = { transactionId: res.data.transactionId, title: res.data.title, createdAt: res.data.createdAt }
					if (res.data.data.url) {
						duitnowState.url = res.data.data.url
					}
					if (res.data.data.image) {
						duitnowState.image = res.data.data.image
					}
					history.push("/guide/duitnow", duitnowState)
				} else if (res.data.data.type === "image" && type === "bangkokbank") {
					history.push("/guide/promptpay", { image: res.data.data.url, transactionId: res.data.transactionId })
				} else {
					history.push("/")
				}
			})
			.catch(err => {
				mySwal.fire(t("Error"), t(err.response.data.error), "error");
				setLoading(false);
			});
	}

	const hitpayPurchase = () => {
		// pay with hitpay (Singapore)
		setLoading(true);
		axios
			.post("/api/token/hitpayPurchase", { userId: user.id, pkgId: selectedPkg.id }, { headers: { "Content-Type": "application/json", "auth-token": token } })
			.then(res => {
				saveTransactionType("Reload")
				setLoading(false);
				if (!res.data.data) {
					history.push("/");
				} else {
					window.location.href = res.data.data;
				}
			})
			.catch(err => {
				mySwal.fire(t("Error"), t(err.response.data.error), "error");
				setLoading(false);
			});
	}

	const pagbankPurchase = () => {
		// pay with PagBank (Brazil)
		let data = {
			country: user.country,
			description: `${selectedPkg.token} ${t("e-Token")}`,
			paymentAmount: selectedPkg.price,
			user,
			pkg: selectedPkg,
			pagbankPublicKey,
		}

		history.push("/payment/pagbank", data)
	}

	const paywayPurchase = () => {
		// pay with PayWay (Cambodia)
		let data = {
			country: user.country,
			description: `${selectedPkg.token} ${t("e-Token")}`,
			paymentAmount: selectedPkg.price,
			user,
			pkg: selectedPkg,
		}

		history.push("/payment/payway", data)
	}

	const cancelPurchase = () => {
		setShowModal(false);
		setCleanproModal(false);
		setSelectedPkg(null)
	}

	const handleSubmit = pkg => {
		setSelectedPkg(pkg)
		if (STORETYPE === "cleanpro") {
			setCleanproModal(true)
		} else {
			setShowModal(true)
		}
	};

	const renderPage = selected === "reload" ? <ReloadList data={data} loading={loading} handleSubmit={handleSubmit} /> : <PurchaseHistory purchaseHistory={user.tokenPurchaseHistory} />;

	return (
		<div id="reload-page">
			<Sidebar toggled={toggled} setToggled={setToggled} />
			{
				STORETYPE === "washup" || STORETYPE === "jomcuci" ? (
					<WashupHeader user={user} setToggled={setToggled} />
				) : (
					<div id="user-header" className={STORETYPE === "cleanpro" ? "d-flex justify-content-between" : ""}>
						<h5>
							<i onClick={e => history.goBack()} className="bi bi-chevron-left me-3"></i> <strong>{STORETYPE !== "cleanpro" ? t("Reload Tokens") : t("Back")}</strong>
						</h5>

						{
							STORETYPE !== "cleanpro" ? (
								<div id="token-info-container">
									<div id="token-image-container">
										<i className="fas bi-coin"></i>
									</div>

									<div id="token-info">
										<h3>{user?.name || ""}</h3>
										<h6>
											{t("Current e-Token")}: <span id="user-token">{user?.token || 0}</span>
										</h6>
									</div>
								</div>
							) : (
								<p className="font-weight-bold" style={{ fontSize: "17px" }}>
									{t("Balance")}: {user?.token || 0} {t("credits")}
								</p>
							)
						}
					</div>
				)
			}

			<div style={{ padding: STORETYPE === "cleanpro" ? "45px 0" : "" }} id="user-body" className={STORETYPE === "cleanpro" ? "" : "mt-5"}>
				{/* <div id="type-selector">
						<button id="reload" onClick={e => setSelect("reload")} className={selectColor("reload")}>
							{t("Reload")}
						</button>
						<button id="history" onClick={e => setSelect("history")} className={selectColor("history")}>
							{t("History")}
						</button>
					</div> */}

				<div /*className="mt-3"*/>{renderPage}</div>
			</div>

			{
				body ? (
					<div>
						<form name={formName} action={url} method="post">
							{
								body.map(b => (
									<input type="hidden" name={b.name} value={b.value} />
								))
							}
							<input type="submit" name="submit" value="Pay" hidden ref={formButtonClick} />
						</form>
					</div>
				) : null
			}

			{
				kipleId ? (
					<div>
						<form action={environment === "development" ? "https://uat.kiplepay.com/wcgatewayinit.php" : "https://kiplepay.com/wcgatewayinit.php"} method="post">
							<input type="hidden" name="ord_date" value={new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })} />
							<input type="hidden" name="ord_totalamt" value={amount} />
							<input type="hidden" name="ord_gstamt" value="0.00" />
							<input type="hidden" name="ord_shipname" value={user.name} />
							<input type="hidden" name="ord_shipcountry" value="Malaysia" />
							<input type="hidden" name="ord_mercref" value={transId} />
							<input type="hidden" name="ord_telephone" value={user.number} />
							{user.email ? <input type="hidden" name="ord_email" value={user.email} /> : null}
							<input type="hidden" name="ord_delcharges" value="0.00" />
							<input type="hidden" name="ord_svccharges" value="0.00" />
							<input type="hidden" name="ord_mercID" value={environment === "development" ? "80000155" : kipleId} />
							<input type="hidden" name="version" value="2.0" />
							<input type="hidden" name="merchant_hashvalue" value={kipleHashValue} />
							<input type="hidden" name="ord_returnURL" value={apiUrl + `/api/token/kiplePayment/success`} />

							<input type="submit" name="submit" value="Pay with kiplePay" hidden ref={kipleButtonClick} />
						</form>
					</div>
				) : null
			}

			<Modal
				show={showModal}
				onHide={() => setShowModal(false)}
				centered
				contentClassName="radius-modal"
			>
				<Modal.Body>
					<div className={theme}>
						<h2 className="text-center">{t("Buy this package?")}</h2>
						{selectedPkg ? <p className="text-center fs-5 mt-3">{t("Purchase")} {selectedPkg.token} {t("e-Tokens for")} {currency(user?.country)} {parseFloat(selectedPkg.price).toFixed(2)}?</p> : null}
						{
							loading ? (
								<div className="text-center">
									<div className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`} role="status">
										<span className="sr-only">Loading...</span>
									</div>
								</div>
							) : (
								<div className="text-center">
									{rm ? <button id="purchase-rm-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("rm")}>{t("Purchase")}</button> : null}
									{kiple ? <button id="purchase-kiple-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("kiple")}>{t("Pay with KiplePay")}</button> : null}
									{scan2pay ? <button id="purchase-scan2pay-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => scan2payPurchase()}>{t("Pay with Scan2Pay")}</button> : null}
									{razer ? <button id="purchase-razer-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("razer")}>{t("Pay with Razer")}</button> : null}
									{hitpay ? <button id="purchase-hitpay-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => hitpayPurchase()}>{t("Pay with HitPay")}</button> : null}
									{duitnow ? <button id="purchase-duitnow-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("duitnow")}>{t("Pay with Duitnow QR")}</button> : null}
									{pagbank ? <button id="purchase-pagbank-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => pagbankPurchase()}>{t("Pay with PagBank")}</button> : null}
									{ghl ? <button id="purchase-ghl-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("ghl")}>{t("Pay with GHL")}</button> : null}
									{thai2c2p ? <button id="purchase-2c2p-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("2c2p")}>{t("Pay with 2c2p")}</button> : null}
									{rhbDuitnow ? <button id="purchase-rhbduitnow-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("rhbduitnow")}>{t("Pay with Duitnow QR")}</button> : null}
									{bangkokbank ? <button id="purchase-bangkokbank-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("bangkokbank")}>{t("Pay with PromptPay QR")}</button> : null}
									{bangkokbankApp ? <button id="purchase-bangkokbankdeeplink-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("bangkokbankapp")}>{t("Pay with Bangkok Bank App")}</button> : null}
									{cybersource ? <button id="purchase-cybersource-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => purchase("cybersource")}>{t("Pay with Card")}</button> : null}
									{payway ? <button id="purchase-payway-token" type="button" className="btn token-reload-button btn-primary mt-2 mx-2" onClick={() => paywayPurchase()}>{t("Pay with PayWay")}</button> : null}
									<button id="cancel-purchase-token" type="button" className="btn btn-danger mt-2 mx-2" onClick={() => cancelPurchase()}>{t("Cancel")}</button>
								</div>
							)
						}
					</div>
				</Modal.Body>
			</Modal>

			<Modal
				show={cleanproModal}
				onHide={() => setCleanproModal(false)}
				centered
			>
				<Modal.Body>
					<div className={theme}>
						<img
							className="d-block"
							src={cleanproReloadBear}
							style={{ width: "30%", margin: "0 auto" }}
							alt=""
						/>
						<h2 className="text-center pt-3">{t("Topup credit")}</h2>
						{selectedPkg ? <p className="text-center fs-5 mt-3">{t("Are you sure to purchase")} {selectedPkg.token} {t("credits for")} {currency(user?.country)} {parseFloat(selectedPkg.price).toFixed(2)}?</p> : null}
						{
							loading ? (
								<div className="text-center">
									<div className={`spinner-border text-${STORETYPE === "cuci" ? "warning" : "primary"}`} role="status">
										<span className="sr-only">Loading...</span>
									</div>
								</div>
							) : (
								<div className="text-center">
									<button id="cancel-purchase-token" type="button" className="btn secondary-button mt-4 mx-2" style={{ height: "50px", width: "45%" }} onClick={() => cancelPurchase()}>{t("Cancel")}</button>
									{rm ? <button id="purchase-rm-token" type="button" className="btn big-button mt-4 mx-2" style={{ width: "45%" }} onClick={() => purchase("rm")}>{t("Pay now")}</button> : null}
									{kiple ? <button id="purchase-kiple-token" type="button" className="btn big-button mt-3 mx-2" style={{ width: "75%" }} onClick={() => purchase("kiple")}>{t("Pay with KiplePay")}</button> : null}
									{scan2pay ? <button id="purchase-scan2pay-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => scan2payPurchase()}>{t("Pay with Scan2Pay")}</button> : null}
									{razer ? <button id="purchase-razer-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => purchase("razer")}>{t("Pay with Razer")}</button> : null}
									{hitpay ? <button id="purchase-hitpay-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => hitpayPurchase()}>{t("Pay with HitPay")}</button> : null}
									{duitnow ? <button id="purchase-duitnow-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => purchase("duitnow")}>{t("Pay with Duitnow QR")}</button> : null}
									{pagbank ? <button id="purchase-pagbank-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => pagbankPurchase()}>{t("Pay with PagBank")}</button> : null}
									{ghl ? <button id="purchase-ghl-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => purchase("ghl")}>{t("Pay with GHL")}</button> : null}
									{thai2c2p ? <button id="purchase-2c2p-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => purchase("2c2p")}>{t("Pay with 2c2p")}</button> : null}
									{rhbDuitnow ? <button id="purchase-rhbduitnow-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => purchase("rhbduitnow")}>{t("Pay with Duitnow QR")}</button> : null}
									{bangkokbank ? <button id="purchase-bangkokbank-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => purchase("bangkokbank")}>{t("Pay with PromptPay QR")}</button> : null}
									{bangkokbankApp ? <button id="purchase-bangkokbankdeeplink-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => purchase("bangkokbankapp")}>{t("Pay with Bangkok Bank App")}</button> : null}
									{cybersource ? <button id="purchase-cybersource-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => purchase("cybersource")}>{t("Pay with Card")}</button> : null}
									{payway ? <button id="purchase-payway-token" type="button" className="btn big-button mt-2 mx-2" style={{ width: "75%" }} onClick={() => paywayPurchase()}>{t("Pay with PayWay")}</button> : null}
								</div>
							)
						}
					</div>
				</Modal.Body>
			</Modal>
			{
				STORETYPE === "washup" || STORETYPE === "jomcuci" ? (
					<>
						<div className="mt-5">
							<h5 className="ml-2 dashboard-promotion-text">
								<strong>{STORETYPE === "washup" || STORETYPE === "jomcuci" ? t("Promotion") : t("Promotions")}</strong>
							</h5>
							<div className="ml-1 pb-5">
								<NewsSlider page="dashboard" history={history} />
							</div>
						</div>
						<Navigator />
					</>
				) : null
			}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		user: state.user.user,
		token: state.user.token,
		theme: state.theme.theme,
		environment: state.user.environment,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		saveTransactionType: (data) => dispatch(saveTransactionType(data)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Reload);
